import { Box } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import useAuth from '../../../hooks/useAuth'
import useIndex from '../../../hooks/useIndex'

const UpBar = ({
    setActiveBar,
    activeBar,
    setActiveNot,
    activeNot,
    userAvatar,
    notifications,
}) => {
    const { auth } = useIndex();
    const { logout } = useAuth();
    // Combinamos notificaciones no leídas + regalos pendientes en el
    // mismo badge. El usuario ve un solo número total de "cosas
    // pendientes" sobre la campana — el panel separa qué es qué.
    const unread = Number(notifications?.unreadCount ?? 0);
    const pendingGifts = Number(notifications?.pendingGiftsCount ?? 0);
    const totalPending = unread + pendingGifts;
    // Cap visual: pasados los 99 mostramos "99+" para no descuadrar el
    // chip dentro del icono de la campana.
    const pendingLabel = totalPending > 99 ? '99+' : String(totalPending);

    return (
        <UpBarCont>
            {/* <!-- TOGGLE BAR --> */}
            <Box
                className={`tglBarLat ${activeBar ? 'act' : ''}`}
                onClick={() => setActiveBar(!activeBar)}
            >
                <i className="fa-solid fa-bars togBarLat"></i>
            </Box>
            {/* <!-- NOTIFICATIONS --> */}
            <Box className="notifbar">
                {/* <!-- USER --> */}
                <Box className="user">
                    <Link to={'/ganacol/dashboard/configuration'} className="useLnk">
                        <span className="username">{auth?.name ?? 'User Name'}</span>
                        <span className="userimage">
                            <img src={userAvatar} alt="user-avatar" id="usrBarSup" />
                        </span>
                    </Link>
                </Box>
                {/* <!-- NOTIFICATIONS --> */}
                <Box className="notBarSup bell-wrap" onClick={() => setActiveNot(!activeNot)}>
                    <i className="fa-regular fa-bell" id="notifBarSupIc"></i>
                    {totalPending > 0 && <span className="bell-badge">{pendingLabel}</span>}
                </Box>
                {/* <!-- HOME --> */}
                <Box className="notBarSup">
                    <Link to={'/'}>
                        <i className="fa-solid fa-house" id="homeBarSupIc"></i>
                    </Link>
                </Box>
                {/* <!-- EXIT --> */}
                <Box className="notBarSup">
                    <span onClick={logout}>
                        <i className="fa-solid fa-right-from-bracket" id="exitBarSupIc"></i>
                    </span>
                </Box>
            </Box>
        </UpBarCont>
    )
}

export default UpBar

const UpBarCont = styled.div`
    width: 100%;
    height: 52px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: linear-gradient(90deg, #0f224d 0%, #243a6b 48%, #1a2f5c 100%);
    border-bottom: 1px solid rgba(214, 170, 58, 0.45);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    color: #f8f4e8;

    .tglBarLat {
        width: 52px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;

        color: #f8f4e8;
        font-size: 1.35rem;
        cursor: pointer;
        transition: 0.25s ease;
        border-right: 1px solid rgba(214, 170, 58, 0.18);

        i {
            transition: 0.25s ease;
        }

        &:hover {
            background: rgba(255, 255, 255, 0.08);
            color: #f3cd61;
        }

        &.act {
            i {
                transform: rotate(180deg);
            }
        }
    }

    .notifbar {
        height: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;

        .user {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 12px;
            transition: 0.25s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.08);
            }

            .useLnk {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 10px;
                text-decoration: none;

                .username {
                    color: #f8f4e8;
                    font-family: 'Lato';
                    letter-spacing: 0.4px;
                    font-size: 0.95rem;
                    max-width: 180px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .userimage {
                    width: 36px;
                    aspect-ratio: 1/1;
                    display: inline-block;
                    border: 2px solid rgba(214, 170, 58, 0.65);
                    border-radius: 50%;
                    overflow: hidden;
                    padding: 2px;
                    background: rgba(255, 255, 255, 0.08);

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }
            }
        }

        .notBarSup {
            height: 100%;
            min-width: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            transition: 0.25s ease;
            cursor: pointer;
            position: relative;

            &.bell-wrap .bell-badge {
                position: absolute;
                top: 8px;
                right: 4px;
                min-width: 18px;
                height: 18px;
                padding: 0 5px;
                border-radius: 999px;
                background: #d32f2f;
                color: #fff;
                font-size: 0.7rem;
                font-weight: 800;
                line-height: 18px;
                text-align: center;
                box-shadow: 0 0 0 2px #1a2f5c;
                pointer-events: none;
            }

            a,
            span {
                text-decoration: none;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            i {
                color: #f8f4e8;
                font-size: 1.5rem;
                transition: 0.25s ease;
            }

            &:hover {
                background: rgba(255, 255, 255, 0.08);

                i {
                    color: #f3cd61;
                    transform: translateY(-1px);
                }
            }
        }
    }

    @media (max-width: 768px) {
        height: 48px;

        .tglBarLat {
            width: 48px;
            height: 48px;
            font-size: 1.2rem;
        }

        .notifbar {
            .user {
                padding: 0 8px;

                .useLnk {
                    .username {
                        display: none;
                    }

                    .userimage {
                        width: 34px;
                    }
                }
            }

            .notBarSup {
                min-width: 42px;
                padding: 0 8px;

                i {
                    font-size: 1.12rem;
                }
            }
        }
    }

    @media (max-width: 420px) {
        height: 44px;

        .tglBarLat {
            width: 44px;
            height: 44px;
        }

        .notifbar {
            .notBarSup {
                min-width: 38px;
                padding: 0 6px;
            }

            .user {
                padding: 0 6px;

                .useLnk .userimage {
                    width: 32px;
                }
            }
        }
    }
`;